import React, { useState, useEffect } from 'react';
import classes from './SpecialBets.module.scss';
import { useTheme } from '../../utils/ThemeContext';
import { useDispatch } from 'react-redux';
import { saveExtraBet } from '../../store/gameSlice';
import clearIcon from '../../assets/images/delete.svg';

function SpecialBets({ colorNumbers, nightMode }) {
  const [colorBeting, setColorBetting] = useState(colorNumbers);
  const [activeBets, setActiveBets] = useState({});
  const [, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { theme } = useTheme();
  const dispatch = useDispatch();

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isAnyObjectSelected = Object.values(activeBets).some(
    (value) => value !== undefined,
  );
  const isAnyBallSelected = colorBeting.some((color) => color.selected);

  const isButtonDisabled = !(isAnyObjectSelected || isAnyBallSelected);

  let bottomObject = [
    {
      firstObject: {
        title: 'First Ball Number Over or Under 15',
        type: 'FirstDrawnOverUnder',
        items: [
          { subTitle: 'Over 20', number: '1.85' },
          { subTitle: 'Under 20', number: '1.80' },
        ],
      },
    },
    {
      secondObject: {
        title: 'Sum of First 5 Balls Over or Under 58',
        type: 'SumFirstXBalls',
        items: [
          { subTitle: 'Over 50', number: '2.00' },
          { subTitle: 'Under 80', number: '1.80' },
        ],
      },
    },
    {
      thirdObject: {
        title: 'More Odd or Even Numbers in First 3 Balls',
        type: 'OddEvenMajority',
        items: [
          { subTitle: 'Odd', number: '1.90' },
          { subTitle: 'Even', number: '1.90' },
        ],
      },
    },
    {
      fourthObject: {
        title: 'Consecutive Numbers',
        type: 'ConsecutiveNumbers',
        items: [
          { subTitle: 'Yes', number: '2.20' },
          { subTitle: 'No', number: '1.70' },
        ],
      },
    },
    {
      fifthObject: {
        title: 'Range of First 3 Balls',
        type: 'RangeFirstX',
        items: [
          { subTitle: 'Range < 20', number: '2.50' },
          { subTitle: 'Range > 20', number: '1.80' },
        ],
      },
    },
    {
      sixthObject: {
        title: 'First 2 Balls are Odd or Even',
        type: 'FirstXOddEven',
        items: [
          { subTitle: 'Odd', number: '1.95' },
          { subTitle: 'Even', number: '1.95' },
        ],
      },
    },
    {
      seventhObject: {
        title: 'Exact Position of a Specific Number',
        type: 'ExactPosition',
        items: [
          { subTitle: 'Pos1', number: '5.00' },
          { subTitle: 'Pos2', number: '4.50' },
          { subTitle: 'Pos3', number: '4.00' },
          { subTitle: 'Pos4', number: '3.50' },
          { subTitle: 'Pos5', number: '3.00' },
        ],
      },
    },
    {
      eighthObject: {
        title: 'All Numbers Above or Below a Certain Value',
        type: 'AboveBelow',
        items: [
          { subTitle: 'All Above 30', number: '2.00' },
          { subTitle: 'All Below 50', number: '2.50' },
          { subTitle: 'Mixed', number: '1.80' },
        ],
      },
    },
    {
      ninthObject: {
        title: 'Mirror Numbers',
        type: 'MirrorNumbers',
        items: [
          { subTitle: '13, 31', number: '6.00' },
          { subTitle: '24, 42', number: '5.50' },
          { subTitle: '56, 65', number: '5.00' },
        ],
      },
    },
    {
      tenthObject: {
        title: 'Lucky Number Placement',
        type: 'LuckyNumberPlacement',
        items: [
          { subTitle: 'Number 7 at Pos4', number: '4.00' },
          { subTitle: 'Number 12 at Pos3', number: '4.50' },
        ],
      },
    },
  ];

  const betHandler = () => {
    const resetColors = colorBeting.map((color) => ({
      ...color,
      selected: false,
    }));
    setColorBetting(resetColors);
    setActiveBets({});
    dispatch(saveExtraBet(activeBets, colorBeting));
  };

  const removeHandlerFunction = () => {
    const resetColors = colorBeting.map((color) => ({
      ...color,
      selected: false,
    }));
    setColorBetting(resetColors);
    setActiveBets({});
  };

  const handleGameClick = (category, index) => {
    setActiveBets((prev) => ({
      ...prev,
      [category]: index,
    }));
  };

  const handleCircleClick = (index) => {
    const updatedColors = colorBeting.map((colorData, idx) => {
      if (idx === index) {
        return { ...colorData, selected: !colorData.selected };
      }
      return colorData;
    });
    const countSelectedColors = updatedColors.filter(
      (color) => color.selected,
    ).length;
    if (countSelectedColors > 4) {
      return;
    }
    setColorBetting(updatedColors);
  };

  return (
    <div className={classes.gameListContainer}>
      <div
        className={`${classes.betsSpecialMobile} ${isOpen ? classes.open : ''}`}
        style={{
          background: nightMode ? theme.selectedColor : theme.backgroundInside,
        }}
      >
        <span
          className={`${classes.gameList_title} `}
          onClick={() => setIsOpen(!isOpen)}
        >
          Special bets
        </span>
      </div>
      <div
        className={`${classes.SpecialBetsCont} ${isOpen ? classes.open : classes.closed}`}
        style={{
          background: nightMode ? theme.selectedColor : theme.backgroundInside,
        }}
      >
        <div className={classes.iconCont} onClick={removeHandlerFunction}>
          <span className={classes.infoInside}>Clear</span>
          <img
            src={clearIcon}
            alt="clear icon"
            className={classes.imageColor}
          />
        </div>
        <div className={classes.innerCont}>
          <span className={classes.titleSpecial}>Special Bets</span>
          <div className={classes.colorsCont}>
            <span className={classes.colorsTitle}>First ball color</span>
            <div className={classes.numbersGrid1}>
              {colorBeting.map((data, index) => (
                <div
                  key={`${data.color}-${index}`}
                  className={`${classes.circle} ${data.selected ? classes.selected : ''}`}
                  style={{
                    border: `2px solid ${data.color}`,
                    backgroundColor: data.selected ? data.color : 'transparent',
                  }}
                  onClick={() => handleCircleClick(index)}
                ></div>
              ))}
            </div>
          </div>

          <div className={classes.betsWrapper}>
            <div className={classes.firstTwoBets}>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[0].firstObject.title}
                </span>
                <div className={classes.firstBetsStyle}>
                  {bottomObject[0].firstObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['firstObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('firstObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[2].thirdObject.title}
                </span>
                <div className={classes.firstBetsStyle}>
                  {bottomObject[2].thirdObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['thirdObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('thirdObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.firstTwoBets}>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[1].secondObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[1].secondObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['secondObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('secondObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[3].fourthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[3].fourthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['fourthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('fourthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.firstTwoBets}>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[4].fifthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[4].fifthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['fifthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('fifthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[5].sixthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[5].sixthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['sixthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('sixthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.firstTwoBets}>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[6].seventhObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[6].seventhObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['seventhObject'] === index ? classes.active : ''}`}
                          onClick={() =>
                            handleGameClick('seventhObject', index)
                          }
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[7].eighthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[7].eighthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['eighthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('eighthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.firstTwoBets}>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[8].ninthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[8].ninthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['ninthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('ninthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={classes.bettingDetails}>
                <span className={classes.titleBetStyle}>
                  {bottomObject[9].tenthObject.title}
                </span>
                <div className={classes.SecondBetsStyle}>
                  {bottomObject[9].tenthObject.items.map((item, index) => (
                    <div
                      key={`${item.subTitle}-${index}`}
                      className={classes.betsCont1}
                    >
                      <div className={classes.btnsBetting}>
                        <button
                          className={`${classes.btnStyle} ${activeBets['tenthObject'] === index ? classes.active : ''}`}
                          onClick={() => handleGameClick('tenthObject', index)}
                          style={{ '--hover-color': theme.hoverColor }}
                        >
                          <span> {item.subTitle}</span>
                          <span className={classes.titleBtn}>
                            {item.number}
                          </span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.betsBtns}>
          <button
            className={`${classes.bettingBtn} ${classes.btnSecondtStyle}`}
            style={{
              '--hover-color': theme.hoverColor,
              boxShadow: theme.boxShadow,
            }}
            disabled={isButtonDisabled}
            onClick={betHandler}
          >
            Re-Bet
          </button>
          <button
            className={`${classes.bettingBtn} `}
            style={{
              background:
                theme.name === 'pick3' ? theme.btnsColor : theme.btnsColor,
              '--hover-color': theme.hoverColor,
              boxShadow: theme.boxShadow,
            }}
            disabled={isButtonDisabled}
            onClick={betHandler}
          >
            Bet
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpecialBets;
